import React from "react";
import { useNavigate } from "react-router-dom";

export default function GeneralDetails() {
  const Navigate = useNavigate();

  return (
    <form className="mx-2">
      <div class="relative z-0 w-full mb-1 group">
        <input
          type="text"
          name="Name"
          class="block py-2.5 px-0 w-full text-sm text-gray-50 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer placeholder-gray-50"
          placeholder="Delivery Name "
          required
        />
      </div>

      <div className="text-center flex w-fit align-middle mt-8 m-auto text-blue-400  pb-2">
        {" "}
        <button
          type="submit"
          className="font-Montserrat font-semibold text-white mr-5 flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center rounded-md py-4 px-2 flex flex-grow"
          style={{ marginRight: "20px" }}
          onClick={() => Navigate("/dashboard/warehouse/printscan")}
        >
          Scan barcode
        </button>
        <div className="font-Montserrat text-black font-semibold mt-4 mx-4">
          OR
        </div>
        <button
          type="submit"
          className="font-Montserrat font-semibold text-white ml-5 flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center rounded-md py-4 px-2 flex flex-grow"
          style={{ marginRight: "20px" }}
          // onClick={() => navigate("/dashboard/warehouse/printscan/barcode-details")}
        >
          Select items & assemblies
        </button>
      </div>

      <div class="relative z-0 w-full mb-6 group">
        <input
          type="date"
          name="date"
          class="block mt-8 py-2.5 px-0 w-full text-sm text-gray-50 rounded-md bg-transparent border border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer placeholder-gray-50"
          placeholder="Dispatch Date "
          required
        />
      </div>
      <div class="relative z-0 w-full mb-6 group">
        <select
          id="customers"
          class=" border mt-8 border-gray-200 text-gray-50 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3 placeholder-gray-50"
          placeholder=" "
          required
        >
          <option selected>Select Customer</option>
          <option value="US">ABC</option>
          <option value="CA">XYZ</option>
          <option value="FR">ABC</option>
          <option value="DE">XYZ</option>
        </select>
      </div>
    </form>
  );
}
